import {
  Button,
  Checkbox,
  CircularProgress,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@material-ui/core';
import { AddCircle, MoreHoriz } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  DEVICES_CREATE,
  DEVICES_EDIT,
  DEVICES_VIEW,
  DEVICE_STATUS,
} from '../../../../constants/DeviceConst';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import SearchIcon from '@material-ui/icons/Search';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import DeviceRestartPopup from '../../../../components/device-restart-popop/Device-Restart-Popup';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import ListFilterMenu from '../../../../shared/list-filter-menu/List-Filter-Menu';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { TableActionButton } from '../../../../shared/table-acitoin-button/TableActionButton';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import { deleteDeviceAPI, updateDevice } from '../../../../utils/devicesRestAPIUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { getUserLevel } from '../../../../utils/RBACUtil';
import { bouquetSelector, channelNumberSelector } from '../../../cms/cmsSlice';
import { devicesLoaderSelector, devicesSelector, fetchDevices } from '../../configurationSlice';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_DEVICE_MONITORING,
} from '../../../../constants/RoleConsts';
import BulkActionCheckBox from '../../../../shared/MultiActionPopUp/BulkActionCheckBox';

const DevicesList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isFullMode,
    setisFullListMode,
    devicesEndpoint,
    selectedHotel,
    devicesWsEndpoint,
    permissions,
  } = props;
  const originalList = useSelector(devicesSelector);
  const loading = useSelector(devicesLoaderSelector);
  const initialStatus = {
    id: '',
    title: '',
    name: '',
    description: '',
    status: false,
    anchorEl: null,
    devices: null,
    warn: false,
  };
  const [devices, setDevices] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [initialDevices, setInitialDevices] = useState([]);
  const [filterMenu, setFilterMenu] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [filterTargetButton, setFilterTargetButton] = useState(null);
  const originalBouquetList = useSelector(bouquetSelector);
  const [selectedValue, setSelectedValue] = useState(initialStatus);
  const channelList = useSelector(channelNumberSelector);
  const [bouquetList, setBouquetList] = useState(null);
  const [searchWord, setSearchWord] = useState('');
  const [tempSearchText, setTempSearchText] = useState('');
  const [searchButton, setSearchButton] = useState(true);
  const [filteredBaseList, setFilteredBaseList] = useState([]);

  const dispatch = useDispatch();

  const [userRole, setUserRole] = useState('');

  (async () => {
    try {
      const role = await getUserLevel();
      setUserRole(role);
    } catch (e) {
      console.error('User role retrieval failed');
    }
  })();

  const { lastMessage, readyState } = useWebSocket(devicesWsEndpoint);
  const connectionStatus = {
    [ReadyState.CONNECTING]: 'Connecting',
    [ReadyState.OPEN]: 'Open',
    [ReadyState.CLOSING]: 'Closing',
    [ReadyState.CLOSED]: 'Closed',
    [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
  }[readyState];

  useEffect(() => {
    if (connectionStatus === 'Open' && lastMessage) {
      const updatedDevice = JSON.parse(JSON.parse(lastMessage.data).message);
      if (updatedDevice) {
        updateDeviceStatus(updatedDevice.udid, updatedDevice.commands.power);
      }
    }
  }, [lastMessage, connectionStatus]);

  useEffect(() => {
    setBouquetList(originalBouquetList);
  }, [originalBouquetList]);

  useEffect(() => {
    if (originalList.length > 0 && bouquetList) {
      const list = originalList.map((device) => {
        const deviceBouquet = getBouquet(device);
        const powerStatus = device.power_status === '' ? 'OFF' : device.power_status;
        return {
          ...device,
          isChecked: false,
          bouquetId: deviceBouquet ? deviceBouquet.id : null,
          bouquetName: deviceBouquet ? deviceBouquet.name : '---',
          power_status: powerStatus,
        };
      });
      setInitialDevices([...list]);
      setFilteredBaseList([...list]);
      setTempSearchText('');
      setSearchButton(true);
      setDevices([...list]);
      resetFilterDataList();
    } else {
      setDevices([]);
      setInitialDevices([]);
      setFilteredBaseList([]);
      setSelectedCount(0);
      setIsAllSelected(false);
      setTempSearchText('');
      setSearchWord('');
      setSearchButton(false);
      resetFilterDataList();
    }
  }, [originalList, bouquetList]);

  useEffect(() => {
    if (initialDevices.length > 0 && searchWord) {
      setDevices(searchWord ? getSearchFiltedList(searchWord) : [...initialDevices]);
    }
  }, [initialDevices, searchWord]);

  useEffect(() => {
    if (devices.length > 0) {
      setSelectedCount(devices.filter((item) => item.isChecked).length);
    }
  }, [devices]);

  useEffect(() => {
    if (initialDevices.length > 0) {
    resetFilterDataList();
    }
  }, [initialDevices.length]);

  useEffect(() => {
    if (loading || devices?.length === 0) return;
    const totalItems = devices?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [devices?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    onsetPage(0);
  }, [selectedHotel]);

  const handleTextSearch = (searchText) => {
    setTempSearchText(searchText);
    const filteredRows = getSearchFiltedList(searchText);
    onsetPage(0);
    setDevices(filteredRows);
    setFilteredBaseList(filteredRecords);
    setSearchWord(searchText);
  };

  const getSearchFiltedList = (searchText) => {
    return filteredBaseList?.filter((item) => {
      return (
        item.area_type_value.toLowerCase().includes(searchText.toLowerCase()) ||
        item.uniquenumber_value.toLowerCase().includes(searchText.toLowerCase()) ||
        item.zone_name.toLowerCase().includes(searchText.toLowerCase())
      );
    });
  };

  const handleCellMenuClick = (event, devices) => {
    event.stopPropagation();
    setSelectedValue({
      id: devices.uniquenumber_value,
      status: false,
      anchorEl: event.currentTarget,
      devices: devices,
      warn: false,
    });
  };

  const onClickView = (e) => {
    e.stopPropagation();
    if (selectedValue && selectedValue.devices) {
      onViewToggle(DEVICES_VIEW, true, selectedValue.devices);
    }
  };

  const onOpenDrawer = (event, type) => {
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.devices);
    handleClose();
  };

  const deleteDevice = async (e, devicesName) => {
    e.stopPropagation();
    setSelectedValue((prev) => ({
      ...prev,
      title: `Are you sure you want to delete`,
      name: devicesName,
      description: '',
      status: true,
      anchorEl: null,
      warn: false,
    }));
  };

  const deleteDeviceAPICall = async (e) => {
    try {
      if (selectedValue && selectedValue.devices) {
        await deleteDeviceAPI(`${devicesEndpoint}/deleteDevices`, {
          areatype_id: selectedValue.devices.area_type_value,
          area_id: selectedValue.devices.zone_name,
        });
        dispatch(fetchDevices(devicesEndpoint + '/getDevices'));
        notificationManager('success', 'Device deleted successfully');
      }
    } catch (e) {
      notificationManager('danger', 'Failed to delete Device');
    } finally {
      handleClose();
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const handleClose = () => {
    setSelectedValue(initialStatus);
  };

  const handleFilterMenu = (event) => {
    setFilterTargetButton(event.currentTarget);
  };

  const resetFilterDataList = (bouquetsArg) => {
    const bouquets = bouquetsArg ?? bouquetList ?? [];
    const filterMenuBouquets = (bouquets || []).map((obj) => ({
      id: obj.id,
      name: obj.name,
      selected: false,
    }));

    const updatedFilterMenu = [
      {
        title: 'All',
        field: 'all',
        subMenu: [],
      },
      {
        title: 'Status',
        field: 'power_status',
        subMenu: [
          { id: 'ON', name: 'On', selected: false },
          { id: 'OFF', name: 'Off', selected: false },
        ],
        hideSearch: true,
      },
      {
        title: 'Bouquet',
        field: 'bouquetId',
        subMenu: filterMenuBouquets, 
      },
      {
        title: 'Area type',
        field: 'area_type',
        subMenu: [
          { id: 'room', name: 'Room Number', selected: false },
          { id: 'location', name: 'Location', selected: false },
        ],
        hideSearch: true,
      },
      {
        title: 'Number type',
        field: 'unique_number_type',
        subMenu: [
          { id: 'serial_no', name: 'Serial Number', selected: false },
          { id: 'udid', name: 'UDID', selected: false },
        ],
        hideSearch: true,
      },
    ];
    setFilterMenu(updatedFilterMenu);
  };

  const handleFilter = (filterItems, field) => {
    if (filterItems) {
      const filteredRows = filterItems.filter((filterKey) => filterKey.selected);
      const updatedFilterMenu = [...filterMenu];
      updatedFilterMenu[updatedFilterMenu.findIndex((o) => o.field === field)].subMenu =
        filterItems;
      filteredRecords(filteredRows, field);
      setFilterMenu(updatedFilterMenu);
    } else {
      filteredRecords(null, field);
    }
  };

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      const filterList = [...filterMenu];
      const delaultFilter = filterList.map((data) => {
        let subMenuData = [];
        if (data.subMenu && data.subMenu.length > 0) {
          subMenuData = data.subMenu.map((subMenu) => {
            return { ...subMenu, selected: false };
          });
        }
        return { ...data, subMenu: subMenuData };
      });
      setFilterMenu(delaultFilter);
      onsetPage(0);
      setDevices(initialDevices);
      setFilteredBaseList(initialDevices);
      return true;
    }
    const filterIdWithFields = filterMenu
      .filter((initialFilter) => initialFilter.subMenu.length > 0)
      .map((filterItem) => {
        const subMenuFiltersId = filterItem.subMenu
          .filter((fItem) => fItem.selected === true)
          .map((fItemId) => fItemId.id);
        if (subMenuFiltersId.length > 0) {
          return {
            id: subMenuFiltersId,
            field: filterItem.field,
          };
        } else return null;
      })
      .filter((item) => item !== null);
    const filteredRecords = initialDevices.filter((offer) => {
      const doesFilterSatisfy = filterIdWithFields.map((filter) =>
        filter.id.includes(offer[filter.field]),
      );
      return !doesFilterSatisfy.includes(false);
    });
    onsetPage(0);
    setDevices(filteredRecords);
    setFilteredBaseList(filteredRecords);
  };

  const handleUpdateStatus = async (device, powerstatus) => {
    const payload = {
      powerstatus,
      areatype_id: device.area_type_value,
      area_id: device.zone_name,
    };
    try {
      const response = await updateDevice(
        devicesEndpoint + '/device/elevate/updatepowerstatus',
        payload,
      );
      if (response.status) {
        updateDeviceStatus(device.uniquenumber_value, powerstatus + '_INPROGRESS');
        notificationManager('success', 'Device status changed successfully');
      } else {
        notificationManager('danger', 'Error occured while updating device status');
      }
    } catch (err) {
      notificationManager('danger', 'Error occured while connecting API');
    }
  };

  const handleMultiRestarts = async () => {
    const payload = devices
      .filter((d) => d.isChecked)
      .map((device) => {
        return {
          powerstatus: 'RESTART',
          areatype_id: device.area_type_value,
          area_id: device.zone_name,
        };
      });

    try {
      const response = await updateDevice(devicesEndpoint + '/device/updatepowerstatus', payload);
      if (response.status) {
        setInitialDevices(
          initialDevices.map((d) => {
            return {
              ...d,
              power_status: d.isChecked ? 'RESTART_INPROGRESS' : d.power_status,
              isChecked: false,
            };
          }),
        );
        notificationManager('success', selectedCount + ' devices restarted successfully');
      } else {
        notificationManager('danger', 'Error occured while restarting multiple devices');
      }
    } catch (err) {
      notificationManager('danger', 'Error occured while connecting API');
    } finally {
      handleClose();
    }
  };

  const getBouquet = (device) => {
    const bouquet = bouquetList?.find((b) => {
      return (
        device?.area_type &&
        device?.area_type_value &&
        b[device?.area_type]?.includes(device?.area_type_value)
      );
    });
    return bouquet || null;
  };

  const getNoChannels = (bouquetId) => {
    return bouquetId && channelList[bouquetId] ? channelList[bouquetId] : 0;
  };

  const handleSelectAll = (event) => {
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    setDevices(
      devices?.map((device) => {
        return { ...device, isChecked: CheckedValue };
      }),
    );
  };

  const handleDeviceCheck = (id) => {
    let index = devices?.findIndex((device) => device?.id === id);
    if (!devices[index]?.isChecked) {
      devices[index] = { ...devices[index], isChecked: true };
    } else {
      devices[index].isChecked = !devices[index]?.isChecked;
    }
    setDevices([...devices]);
    const checkedItems = devices?.filter((device) => device?.isChecked);

    if (checkedItems?.length === 0) {
      setIsAllSelected(false);
      return;
    }
    const isAllSelected = devices?.every((device) => device?.isChecked);
    setIsAllSelected(isAllSelected);
  };

  const updateDeviceStatus = (udid, newStatus) => {
    setInitialDevices(
      initialDevices.map((d) => {
        return {
          ...d,
          power_status: d.uniquenumber_value === udid ? newStatus : d.power_status,
        };
      }),
    );
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedCount > 0 && selectedValue?.warn && (
        <DeviceRestartPopup
          currentStatus={selectedValue}
          onCancel={handleClose}
          onRestart={handleMultiRestarts}
          selectedCount={selectedCount}
        />
      )}
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteDeviceAPICall}
          onDeleteCancel={() => {
            setSelectedValue(initialStatus);
          }}
        />
      )}
      <div className='row mx-2 d-flex'>
        <div className='col-12 col-lg-4'>
          <TextField
            className='w-100'
            onChange={(e) => {
              handleTextSearch(e.target.value);
              setSearchButton(e?.target?.value ? false : true);
            }}
            label='Search'
            value={tempSearchText}
            InputProps={
              searchButton && {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }
          />
        </div>

        <div className='col-12 col-lg-8 pt-3 pt-lg-0 d-flex justify-content-end align-items-center'>
          {devices && (
            <>
              {selectedCount > 0 && (
                <div className='d-flex align-items-center'>
                  <div className='me-2'>
                    {`${selectedCount} ${selectedCount === 1 ? 'Device' : 'Devices'} Selected`}
                  </div>
                </div>
              )}
              <Button
                variant='outlined'
                color='secondary'
                size='large'
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => {
                  handleFilterMenu(e);
                }}
                className={
                  filterMenu?.some((f) => f?.subMenu?.some((s) => s?.selected))
                    ? 'me-2 filterButton'
                    : 'me-2 dropdown-button'
                }
              >
                Filter
              </Button>
              <ListFilterMenu
                menu={filterMenu}
                targetEl={filterTargetButton}
                handleFilterClose={() => setFilterTargetButton(null)}
                handleFilter={(items, field) => {
                  handleFilter(items, field);
                }}
                hideSearch={false}
              />
            </>
          )}
          {permissions[RBAC_TYPE_DEVICE_MONITORING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS &&
            selectedCount === 0 && (
              <Button
                variant='contained'
                color='primary'
                size='large'
                startIcon={<AddCircle />}
                onClick={(e) => {
                  onOpenDrawer(e, DEVICES_CREATE);
                }}
              >
                Add Device
              </Button>
            )}
          {selectedCount > 0 && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              onClick={() => {
                setSelectedValue({ ...selectedValue, warn: true });
              }}
            >
              Restart
            </Button>
          )}
          {!isFullMode && (
            <div
              className='open-in-full-btn ms-3'
              onClick={() => {
                onsetRowsPerPage(10);
                setisFullListMode(true);
              }}
            >
              <OpenInFullIcon />
            </div>
          )}
        </div>
      </div>

      <div className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          devices &&
          devices.length > 0 && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <BulkActionCheckBox
                        checked={isAllSelected || false}
                        className='check-box'
                        selectedLength={false}
                        totalLength={devices?.length}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell className='w-10'>Room No / Location</TableCell>
                    <TableCell className='w-10'>Zone</TableCell>
                    <TableCell align='center' className='w-10'>
                      No Of Channels
                    </TableCell>
                    <TableCell className='w-30'>Unique Number</TableCell>
                    <TableCell className='w-10'>Bouquet</TableCell>
                    <TableCell align='center' className='w-10'>
                      Status
                    </TableCell>
                    <TableCell align='center' className='w-30'>
                      Action
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? devices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : devices
                  ).map((device, i) => (
                    <TableRow key={i} className='border-white pointer'>
                      <TableCell>
                        {!DEVICE_STATUS[device.power_status]?.loader && (
                          <Checkbox
                            checked={device?.isChecked || false}
                            className='check-box'
                            onChange={() => {
                              handleDeviceCheck(device?.id);
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell>{device.area_type_value}</TableCell>
                      <TableCell>{device.zone_name}</TableCell>
                      <TableCell align='center'>{getNoChannels(device.bouquetId)}</TableCell>
                      <TableCell>
                        {device.unique_number_type === 'serial_no' ? 'Serial Number : ' : 'UDID : '}
                        {device.uniquenumber_value}
                      </TableCell>
                      <TableCell>{device.bouquetName}</TableCell>
                      <TableCell align='center' className='devices-status-label'>
                        <span
                          className={DEVICE_STATUS[device.power_status]?.className || 'text-gray'}
                        >
                          {DEVICE_STATUS[device.power_status]?.label}
                        </span>
                      </TableCell>
                      <TableCell align='center'>
                        {device.power_status && device.power_status === 'ON' ? (
                          <div className='d-flex align-items-center justify-content-center'>
                            <div className='action-btn-seperator'>
                              <TableActionButton
                                btnClass='red-button'
                                onClick={(e) => {
                                  handleUpdateStatus(device, 'OFF');
                                }}
                                label='Off'
                              />
                            </div>
                            <div>
                              <TableActionButton
                                btnClass='yellow-button'
                                onClick={(e) => {
                                  handleUpdateStatus(device, 'RESTART');
                                }}
                                label='Restart'
                              />
                            </div>
                          </div>
                        ) : (
                          device.power_status &&
                          device.power_status === 'OFF' && (
                            <div className='d-flex align-items-center justify-content-center'>
                              <div>
                                <TableActionButton
                                  btnClass='green-button'
                                  onClick={(e) => {
                                    handleUpdateStatus(device, 'ON');
                                  }}
                                  label='On'
                                />
                              </div>
                            </div>
                          )
                        )}
                        {DEVICE_STATUS[device.power_status]?.loader && (
                          <CircularProgress size={20} />
                        )}
                      </TableCell>
                      <TableCell align='right'>
                        {permissions[RBAC_TYPE_DEVICE_MONITORING] ===
                          RBAC_PERMISSION_LEVEL_FULL_ACCESS &&
                          !DEVICE_STATUS[device.power_status]?.loader && (
                            <Button
                              aria-controls='simple-menu'
                              aria-haspopup='true'
                              onClick={(e) => {
                                handleCellMenuClick(e, device);
                              }}
                            >
                              <MoreHoriz />
                            </Button>
                          )}
                        <Menu
                          id={i}
                          anchorEl={selectedValue?.anchorEl}
                          disableRestoreFocus
                          MenuListProps={{ autoFocusItem: false }}
                          keepMounted
                          open={
                            Boolean(selectedValue.anchorEl) &&
                            selectedValue.id === device.uniquenumber_value
                          }
                          onClose={handleClose}
                          className='shadow'
                        >
                          <MenuItem
                            className='pe-4'
                            onClick={(e) => {
                              onOpenDrawer(e, DEVICES_EDIT);
                            }}
                          >
                            <CreateIcon className='me-2 action-menu-icon' />
                            Edit
                          </MenuItem>
                          <MenuItem
                            className='pe-4'
                            onClick={(e) => {
                              onClickView(e);
                            }}
                          >
                            <VisibilityIcon className='me-2 action-menu-icon' />
                            View
                          </MenuItem>
                          <MenuItem
                            className='pe-4'
                            onClick={(e) => {
                              deleteDevice(e, device.zone_name);
                            }}
                          >
                            <DeleteForeverIcon className='me-2 action-menu-icon' />
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  {isFullMode && (
                    <TableRow className='paginator'>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        count={devices.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { 'aria-label': 'rows per page' },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  )}
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
      </div>
    </div>
  );
};

export default DevicesList;
